import React from "react";
import {
    GenericTable,
    GenericTableColumn,
} from "@ui-components/Table/GenericTable";
import { formatDelayMs } from "../ResourceManager/Topology/utils/latencyMatrix";
import { SiteNeighbour, SiteNeighbours, shortSiteLabel } from "./siteLatencyLookup";

const Neighbour: React.FC<{ neighbour: SiteNeighbour | null }> = ({
    neighbour,
}) => {
    if (!neighbour) {
        return <span className="text-sm text-semantic-text-secondary">—</span>;
    }
    return (
        <span className="flex items-baseline justify-between gap-3 text-sm">
            <span className="text-semantic-text-primary" title={neighbour.site.label}>
                {shortSiteLabel(neighbour.site.label)}
            </span>
            <span className="tabular-nums text-semantic-text-secondary">
                {formatDelayMs(neighbour.rttUs)} ms
            </span>
        </span>
    );
};

const COLUMNS: GenericTableColumn<SiteNeighbours>[] = [
    {
        header: "SITE",
        accessor: "site",
        sortAccessor: (row) => shortSiteLabel(row.site.label),
        wrapMode: "nowrap",
        renderCell: (row) => (
            <span
                className="text-sm font-semibold text-semantic-text-primary"
                title={row.site.label}
            >
                {shortSiteLabel(row.site.label)}
            </span>
        ),
    },
    {
        header: "CLOSEST SITE",
        accessor: "closest",
        sortAccessor: (row) => row.closest?.rttUs ?? null,
        renderCell: (row) => <Neighbour neighbour={row.closest} />,
    },
    {
        header: "FARTHEST SITE",
        accessor: "farthest",
        sortAccessor: (row) => row.farthest?.rttUs ?? null,
        renderCell: (row) => <Neighbour neighbour={row.farthest} />,
    },
];

/** One row per site: where it reaches fastest and slowest, by round trip. */
const SiteNeighboursTable: React.FC<{ rows: SiteNeighbours[] }> = ({ rows }) => (
    <GenericTable
        columns={COLUMNS}
        data={rows}
        rowKey={(row) => row.site.id}
        tableClassName="bg-semantic-bg-primary"
        width="100%"
        isFooterVisible={false}
    />
);

export default SiteNeighboursTable;
